import { render, staticRenderFns } from "./CrmModuleMenu.vue?vue&type=template&id=bd15ebdc"
import script from "./CrmModuleMenu.vue?vue&type=script&lang=js"
export * from "./CrmModuleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports